import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div
      className="tabing_section healthcare_tabs_sec p-100"
      style={{ background: "#f8f8f8" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={9} lg={7} className="m-auto text-center">
            <h3 className="h3_head">
              Toolchain We Use for <span>CMS Development</span>
            </h3>
            <p>
              We employ novel, useful-only technologies to build efficient
              content management systems for greater content control and
              improved digital strategy. Our tech stack for CMS development
              services is finely picked to achieve high throughput, low latency,
              and dynamic content management.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/frontend/tailwind_css.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Tailwind CSS</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/NueJs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>VueJs</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>ReactJS</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/backend/Django.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Django</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/backend/Laravel.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Laravel</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/backend/Node-js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/my_sql.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="CMS Platforms">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/Contentful.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Contentful</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/Drupal.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Drupal</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/Ghos.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Ghos</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/Joomla.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Joomla</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/Strapi.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Strapi</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/cms-platforms/WordPress.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>WordPress</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="DevOps">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/devops/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/devops/GitHub_Actions.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitHub</h6>
                  </div>
                </li>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/cms-development/devops/Kubernetes.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Kubernetes</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Security">
              <ul>
                <li style={{ background: "transparent" }}>
                  <StaticImage
                    src="../../images/services-usa/ecommerce_web/security/JWT.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>JWT</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
